import React from 'react';

const DeleteUserModal = ({
  showDeleteModal,
  selectedUser,
  dependencyTree,
  loadingDependencies,
  onClose,
  onConfirm
}) => {
  if (!showDeleteModal || !selectedUser) return null;

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: '600px' }}>
        <div className="modal-header">
          <h2>Delete User</h2>
          <button
            onClick={onClose}
            className="modal-close-btn"
          >
            ×
          </button>
        </div>
        <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          <div className="delete-permission-info">
            <div className="permission-to-delete">
              <strong>User:</strong> <code>{selectedUser.name}</code>
              <p className="text-gray-600 text-sm mt-1">{selectedUser.email} ({selectedUser.username})</p>
            </div>

            {loadingDependencies ? (
              <div className="dependency-loading">
                <div className="loading-spinner-small"></div>
                <p>Loading dependency information...</p>
              </div>
            ) : dependencyTree ? (
              <div className="dependency-tree">
                <h3 className="dependency-header">
                  <span className="tree-icon">🔍</span>
                  Dependency Analysis
                </h3>

                <div className="dependency-content">
                  <div className="dependency-summary">
                    <div className="summary-item">
                      <span className="summary-icon">👥</span>
                      <div>
                        <strong>{dependencyTree.roles?.length || 0}</strong>
                        <span className="summary-label">Role{(dependencyTree.roles?.length || 0) !== 1 ? 's' : ''} Assigned</span>
                      </div>
                    </div>
                    <div className="summary-item">
                      <span className="summary-icon">🔐</span>
                      <div>
                        <strong>{dependencyTree.sessions?.length || 0}</strong>
                        <span className="summary-label">Active Session{(dependencyTree.sessions?.length || 0) !== 1 ? 's' : ''}</span>
                      </div>
                    </div>
                    <div className="summary-item">
                      <span className="summary-icon">📝</span>
                      <div>
                        <strong>{dependencyTree.auditLogs || 0}</strong>
                        <span className="summary-label">Audit Log{(dependencyTree.auditLogs || 0) !== 1 ? 's' : ''}</span>
                      </div>
                    </div>
                    <div className="summary-item">
                      <span className="summary-icon">📄</span>
                      <div>
                        <strong>{dependencyTree.createdRecords || 0}</strong>
                        <span className="summary-label">Created Record{(dependencyTree.createdRecords || 0) !== 1 ? 's' : ''}</span>
                      </div>
                    </div>
                  </div>

                  {dependencyTree.roles && dependencyTree.roles.length > 0 && (
                    <div className="affected-roles-tree">
                      <h4 className="tree-section-title">Assigned Roles:</h4>
                      <ul className="tree-list">
                        {dependencyTree.roles.map((role) => (
                          <li key={role.id} className="tree-item">
                            <div className="tree-node">
                              <span className="node-icon">📋</span>
                              <div className="node-content">
                                <strong className="role-name">{role.name}</strong>
                                <span className="role-description">{role.description}</span>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {(dependencyTree.roles?.length > 0 || dependencyTree.sessions?.length > 0 || dependencyTree.auditLogs > 0 || dependencyTree.createdRecords > 0) && (
                    <div className="warning-message">
                      <span className="warning-icon">⚠️</span>
                      <div>
                        <strong>Warning:</strong> Deleting this user will cascade and permanently remove:
                        <ul style={{ marginTop: '0.5rem', marginLeft: '1rem' }}>
                          {dependencyTree.roles?.length > 0 && (
                            <li>{dependencyTree.roles.length} role assignment{dependencyTree.roles.length !== 1 ? 's' : ''}</li>
                          )}
                          {dependencyTree.sessions?.length > 0 && (
                            <li>{dependencyTree.sessions.length} active session{dependencyTree.sessions.length !== 1 ? 's' : ''}</li>
                          )}
                          {dependencyTree.auditLogs > 0 && (
                            <li>References in {dependencyTree.auditLogs} audit log entr{dependencyTree.auditLogs !== 1 ? 'ies' : 'y'} (will be set to null)</li>
                          )}
                          {dependencyTree.createdRecords > 0 && (
                            <li>Association with {dependencyTree.createdRecords} created record{dependencyTree.createdRecords !== 1 ? 's' : ''}</li>
                          )}
                        </ul>
                        <p style={{ marginTop: '0.5rem', fontStyle: 'italic' }}>This action cannot be undone.</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            <p className="confirm-message">Are you sure you want to delete this user?</p>
          </div>
        </div>
        <div className="modal-footer">
          <button
            onClick={onClose}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-danger"
            disabled={loadingDependencies}
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;

